import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFoundPage() {
  return (
    <main
      className="min-h-[85vh] flex items-center justify-center px-6 pt-32 pb-24"
      data-testid="notfound-page"
    >
      <div className="max-w-xl text-center">
        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-8 bg-[#D4AF37]" />
          <span className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
            Error 404
          </span>
          <span className="h-px w-8 bg-[#D4AF37]" />
        </div>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[1.02]">
          Page not found.
          <br />
          <span className="text-[#D4AF37]">Let's find our way back.</span>
        </h1>
        <p className="mt-6 text-base text-slate-400 leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="mt-9 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#D4AF37] text-[#1f2935] font-semibold text-[12px] uppercase tracking-[0.22em] hover:bg-[#B48600] transition-colors"
        >
          Back home <ArrowRight size={13} strokeWidth={2} />
        </Link>
      </div>
    </main>
  );
}
